var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{class:_vm.iconClass,attrs:{"xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}},[_c('use',{attrs:{"xlink:href":`/icons.svg#${_vm.name}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }